import Doctor from "../components/doctors/doctor"
function Doctors(){
    return(
        <>
        <Doctor/>
        </>
    )
}
export default Doctors